import React, { useState } from "react";
import { TimestampToDateMoment } from "../../../utils/timestampToDate";
import { Alert } from "@material-ui/lab";
import PageSpinner from "../../elements/spinner/PageSpinner";
import RenderStatus from "../../styles/styledStatus";
import Notification from "../../elements/notification/Notification";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import { Accordion, AccordionSummary } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../styles/styledTable";
import { StyledCopy } from "../../styles/styledCopy";
import { StyledBreakWord } from "../../styles/styledBreakWord";

const RiskScoreList = ({ riskScore }) => {
  const { t } = useTranslation("riskScorePage");

  const [copy, setCopy] = useState(false);
  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const [expanded, setExpanded] = useState();

  if (!riskScore) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  const handleChange = (panel) => {
    return (event, newExpanded) => {
      setExpanded(newExpanded ? panel : false);
    };
  };

  if (riskScore.length === 0) {
    return <Alert severity="warning">{t("table.emptyData")}</Alert>;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledScrollTable style={{ position: "relative" }}>
        <StyledTable
          width="1480"
          size="16"
          className="risk-score-table"
        >
          <StyledTableHead
            scroll="auto"
            col="8"
            className="risk-score-table__head"
          >
            <div>
              {t("table.project")}
            </div>
            <div>
              {t("table.currency")}
            </div>
            <div>
              {t("table.address")}
            </div>
            <div>
              Tx-hash
            </div>
            <div>
              {t("table.risk")}
            </div>
            <div>
              {t("table.status")}
            </div>
            <div>
              {t("table.date")}
            </div>
            <div>
              {t("table.details")}
            </div>
          </StyledTableHead>
          <StyledTableBody>
            {riskScore && riskScore.map((value, key) => (
              <Accordion expanded={expanded === key} onChange={handleChange(key)}>
                <AccordionSummary
                  className="accordion-title"
                  aria-controls={key}
                  id={key}
                >
                  <StyledTableRow
                    key={key}
                    scroll="auto"
                    col="8"
                    className="risk-score-table__row"
                  >
                    <StyledCol className="risk-score-table__project">
                      {value.connection.project.name}
                    </StyledCol>
                    <StyledCol inline className="risk-score-table__currency">
                      <StyledBreakWord as="p">
                        {value.attributes[2].value}
                      </StyledBreakWord>
                    </StyledCol>

                    <StyledCol inline>
                      <StyledBreakWord as="p">
                        {value.attributes[0].value}
                        <CopyToClipboard
                          text={value.attributes[0].value}
                          onCopy={() => {
                            setCopy(true);
                            setNotification({
                              ...notification,
                              visible: true,
                              type: "success",
                              message: t("table.copied")
                            });
                          }}
                        >
                          <StyledCopy title={t("table.copy")} className="icon-light-copy" />
                        </CopyToClipboard>
                      </StyledBreakWord>
                    </StyledCol>
                    <StyledCol inline>
                      <StyledBreakWord as="p">
                        {value.attributes[1].value}
                        <CopyToClipboard
                          text={value.attributes[1].value}
                          onCopy={() => {
                            setCopy(true);
                            setNotification({
                              ...notification,
                              visible: true,
                              type: "success",
                              message: t("table.copied")
                            });
                          }}
                        >
                          <StyledCopy title={t("table.copy")} className="icon-light-copy" />
                        </CopyToClipboard>
                      </StyledBreakWord>
                    </StyledCol>
                    <StyledCol className="risk-score-table__level">
                      {value.flowData.length > 1 ? value.flowData[0].value : t("table.flowDataError")}
                    </StyledCol>
                    <StyledCol
                      inline
                      className="risk-score-table__status"
                    >
                      <RenderStatus status={value.status.value} />
                    </StyledCol>
                    <StyledCol className="risk-score-table__date">
                      {TimestampToDateMoment(value.createdAt)}
                    </StyledCol>
                    <StyledCol className="risk-score-table__action">
                      <span className={`icon-light-chevron-${expanded === key ? "down" : "right"}`} />
                    </StyledCol>
                  </StyledTableRow>
                </AccordionSummary>
                <div className="accordion-content">
                  {value.flowData.length !== 0 ?
                    Object.entries(JSON.parse(value.flowData.length > 1 ? value.flowData[1].value : value.flowData[0].value)).map(([key, value], arrKey) => (
                      <div key={arrKey} className={`accordion-content__item accordion-content_${key}`}>
                        <span>{key}</span>: <StyledBreakWord as="b">{value}</StyledBreakWord>
                      </div>
                    )) : <Alert className="accordion-content__alert" severity="warning">{t("table.emptyDetails")}</Alert>}
                </div>
              </Accordion>
            ))}
          </StyledTableBody>
        </StyledTable>
      </StyledScrollTable>
    </>
  );
};

export default RiskScoreList;